
<template>
    <span :class="{'circle-status': true, green: enabled, red: !enabled}" :title="title"></span>
</template>

<script>

export default {
  name: 'circleStatus',
  props: {
    enabled: { required: true },
    title: { type: String, default: '' }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/circleStatus.vue